<script>
    import { required, maxLength } from "vuelidate/lib/validators";
    import validationMessages from "@/components/validations";
    import Notification from "@/services/Notification";
    import Swal from "sweetalert2";

    export default {
        components: { validationMessages },
        props: ['attributesData'],
        data() {
            return {
                type: [],
                type_e: [],
                title: '',
                attribute:'',
                attributeValue:'',
                selectedType: '',
                message: '',
                showModal: false,
                submitted: false,
                tryingToSubmit: false,
                showLoader: false,
                csrf_token: localStorage.getItem("csrf_token"),
                error: null,
            };
        },

        validations: {
            attributeValue: {
              required
            }
        },

        watch: {
            attributesData(newVal) {
                this.attribute = newVal.attribute;
                this.attributeValue = newVal.value;

            }
        },

        methods: {
            closeModal() {
                this.showModal = false;
                this.submitted = false;
            },

            successmsg(message) {
                Swal.fire("Success", message, "success");
            },

            failedmsg(message) {
                Swal.fire("Error", message, "error");
            },

            refreshData() {
                this.$emit("onRefresh");
            },

            resetForm() {
                this.attribute=''
                this.attributeValue=''
                this.$v.$reset();
            },

            modalShown(){

            }
        },
    };
</script>

<template>
    <b-modal @shown="modalShown" id="edit_automated_notification_attributes" size="l" v-model="showModal" @hidden="resetForm" title="Edit Automated Notification Attributes" title-class="font-18">
        <form v-if="!showLoader">
            <div class="row">
                <div v-if="$v.$error" class="text-danger">Complete all fields</div>
                <b-card-text>
                    <div class="row">
                        <div class="col-sm-12">
                            <b-form-group label="Attribute" label-for="formrow-title-input" class="mb-3">
                                <b-form-input disabled v-model.trim="attribute"></b-form-input>
                            </b-form-group>

                            <b-form-group label="Value" label-for="formrow-Message-input" class="mb-3">
                                <b-form-input v-model.trim="attributeValue"></b-form-input>
                              <validationMessages v-if="submitted" :fieldName="'Notification Attribute Value'" :validationName="$v.attributeValue"></validationMessages>
                            </b-form-group>

                            <input type="hidden" name="csrf_token" v-model="csrf_token">
                        </div>
                    </div>
                </b-card-text>
            </div>
        </form>
        <div class="card-body d-flex align-items-center justify-content-center" v-else>
            <b-spinner large></b-spinner>
        </div>
        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary"  :disabled="tryingToSubmit || showLoader">
                <b-spinner v-show="tryingToSubmit" small></b-spinner>
                Submit
            </b-button>
        </template>
    </b-modal>
</template>
